const route = [
  {
    path: '/speechbank/:tenant',
    name: 'speechbank',
    component: () =>
      import(/* webpackChunkName: 'speechbank' */ '@/views/speechbank'),
    meta: { routeName: '话术库', unGetUser: true },
  },
  {
    path: '/createAndEdit',
    name: 'createAndEdit',
    component: () =>
      import(
        /* webpackChunkName: 'createAndEdit' */ '@/views/speechbank/createAndEdit'
      ),
    meta: { routeName: '话术库', unGetUser: true },
  },
];
export default route;
